// Entry times were saved in older formats before settling on M:SS.mm
// (2-digit centiseconds, dot separator) — this normalizes any of those
// older shapes (M:SS:mm, M:SS:mmm) for display without touching what's
// actually stored in the database.
const OLD_FORMAT_RE = /^(\d{1,2}):([0-5]\d)[:.](\d{2,3})$/;

export function displayEntryTime(time) {
  const m = OLD_FORMAT_RE.exec(time || "");
  if (!m) return time || "";
  const [, minutes, seconds, frac] = m;
  const centis = frac.length === 3 ? Math.round(Number(frac) / 10) : Number(frac);
  return `${minutes}:${seconds}.${String(Math.min(centis, 99)).padStart(2, "0")}`;
}
